<template>
  <div
    class="d-flex breadcrumb-tasklist align-center"
    aria-label="breadcrumb"
    data-testid="breadcrumb-container"
  >
    <span
      v-for="(item, index) in items"
      :key="`breadcrumb-${index}`"
      class="d-flex align-center"
    >
      <p
        v-if="!isClickable(item)"
        class=""
        :class="{ noTransform: item.noTransform }"
        :data-testid="item.testId"
      >
        {{ item.text }}
      </p>

      <router-link
        v-else-if="item.to"
        :to="item.to"
        class="breadcrumb-link"
        :data-testid="item.testId"
      >
        <p class="" :class="{ noTransform: item.noTransform }">
          {{ item.text }}
        </p>
      </router-link>

      <a
        v-else
        href="javascript:void(0)"
        class="breadcrumb-link"
        :data-testid="item.testId"
        @click.prevent="onItemClick(item)"
      >
        <p class="" :class="{ noTransform: item.noTransform }">
          {{ item.text }}
        </p>
      </a>

      <p
        v-if="index < items.length - 1"
        class="px-2"
        data-testid="breadcrumb-separator"
      >
        /
      </p>
    </span>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumb',

  props: {
    items: {
      type: Array,
      required: false,
      default: () => []
    }
  },

  methods: {
    isClickable(item) {
      if (item.disabled) {
        return false;
      }
      return Boolean(item.click || item.to || item.href);
    },

    onItemClick(item) {
      if (item.click) {
        item.click();
        return;
      }

      if (item.href) {
        if (item.href.startsWith('/')) {
          this.$router.push(item.href);
        } else {
          window.location.href = item.href;
        }
      }
    }
  }
};
</script>

<style scoped>
.breadcrumb-tasklist {
  align-items: center;
}

.noTransform {
  text-transform: none;
}

.breadcrumb-link {
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s;
  color: var(--color-breadcrumb-text);
}
</style>
